import { ChatAdapter, ParticipantResponse, Message, IChatParticipant } from 'ng-chat';
import { Observable } from 'rxjs';
import { ChatService } from './chat.service';

export class NzkChatAdapter extends ChatAdapter {

  participantList: ParticipantResponse[];
  
  constructor(private fileId: number, private userId: number, private chatService: ChatService){
    super();
    this.chatService.participantList$.subscribe(list => {
      this.participantList = list;
      this.onFriendsListChanged(this.participantList);
    })
  }

  listFriends(): Observable<ParticipantResponse[]> {
    return this.chatService.getChatSubjects(this.fileId, this.userId);
  }

  getMessageHistory(destinataryId: any): Observable<Message[]> {
    return this.chatService.getChatHistory(destinataryId);
  }

  sendMessage(message: Message): void {
    this.chatService.sendMessage(message, this.fileId);
  }

  onMessageReceived(participant: IChatParticipant, message: Message): void {
    this.messageReceivedHandler(participant, message);
  }

  onFriendsListChanged(participantsResponse: ParticipantResponse[]): void {
    this.friendsListChangedHandler(participantsResponse);
  }

  friendsListChangedHandler: (participantsResponse: ParticipantResponse[]) => void;

  messageReceivedHandler: (participant: IChatParticipant, message: Message) => void;

}